import { List, ListItem, Typography } from '@mui/material'
import React from 'react'
import theme from '../../muiTheme'

const Figures = ({ list }) => {
	return (
		<List
			color="white"
			sx={(theme) => ({
				display: 'flex',
				flexDirection: 'row',
				m: (theme) => theme.spacing(3, 0),

				[theme.breakpoints.down('md')]: {
					flexDirection: 'column',

					mt: 0,
					'& li': {
						borderTop: `1px solid ${theme.palette.text.white}`,
						'&:first-of-type': {
							border: 0,
						},
					},
				},
			})}
		>
			{list.map(({ figure, label }, index) => (
				<ListItem
					key={index}
					sx={{
						flexDirection: 'column',
						[theme.breakpoints.down('md')]: {},
						pb: 4,
						pt: 6,
					}}
				>
					<Typography
						component="h6"
						color="secondary"
						sx={{ display: 'block', fontSize: 34, fontWeight: 800 }}
					>
						{figure}
					</Typography>
					<Typography
						component="p"
						color="white"
						sx={{ fontSize: 18, fontWeight: 400, textAlign: 'center' }}
					>
						{label}
					</Typography>
				</ListItem>
			))}
		</List>
	)
}

export default Figures
